"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PaymentMethodCard = function PaymentMethodCard(_ref) {
  var text = _ref.text,
      _ref$icons = _ref.icons,
      icons = _ref$icons === void 0 ? [] : _ref$icons,
      _ref$highlighted = _ref.highlighted,
      highlighted = _ref$highlighted === void 0 ? false : _ref$highlighted;
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      backgroundColor: highlighted ? '#ffffff3f' : 'none',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-end',
      width: '100%',
      minHeight: 50,
      padding: '12px 30px'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      fontSize: '1rem',
      flex: '1',
      marginRight: 30,
      fontWeight: 600
    }
  }, text), icons);
};

var _default = PaymentMethodCard;
exports["default"] = _default;